"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackFacebookPixel = void 0;

var _Console = require("../common/Console");

var TrackFacebookPixel = function TrackFacebookPixel() {
  var _window;

  if (typeof window === 'undefined') return false;
  if (!window.fbq) return (0, _Console.warn)('LoadFacebookPixel must be called first or FacebookPixel should be loaded manually');
  return (_window = window).fbq.apply(_window, arguments);
};

exports.TrackFacebookPixel = TrackFacebookPixel;